import _taggedTemplateLiteral from "/codebuild/output/src997666004/src/github.com/EverlyWell/www/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  ", "\n  color: ", ";\n  text-decoration: none;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  ", "\n  margin-bottom: ", "px;\n  list-style-type: none;\n\n  &:last-child {\n    margin-bottom: 0;\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  padding-bottom: ", "px;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  padding: 14px 0;\n  color: ", ";\n\n  div {\n    margin-right: ", "px;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import styled from "styled-components";
import { typography, size, colors } from "../../../shared/constants";
import Accordion from "../../Accordion";
export var AccordionHeading = styled(Accordion.Heading)(_templateObject(), colors.green5, size.md);
export var CategoryList = styled.ul(_templateObject2(), size.md);
export var CategoryListItem = styled.li(_templateObject3(), typography.buttonTextSmall, size.md);
export var FooterLink = styled.a(_templateObject4(), typography.buttonTextSmall, colors.green5);